import React from 'react';
import CrtTitle from "./crtTitle";
import './App.css';

// Public reference streams from open standards and frameworks; each renders as a
// tall panel with the lines scrolling through it
const STANDARD_STREAMS = [
  { title: "OWASP TOP 10:2021", lines: [
    "A01:2021 Broken Access Control",
    "A02:2021 Cryptographic Failures",
    "A03:2021 Injection",
    "A04:2021 Insecure Design",
    "A05:2021 Security Misconfiguration",
    "A06:2021 Vulnerable and Outdated Components",
    "A07:2021 Identification and Authentication Failures",
    "A08:2021 Software and Data Integrity Failures",
    "A09:2021 Security Logging and Monitoring Failures",
    "A10:2021 Server-Side Request Forgery (SSRF)",
  ]},
  { title: "OWASP API SECURITY 2023", lines: [
    "API1:2023 Broken Object Level Authorization",
    "API2:2023 Broken Authentication",
    "API3:2023 Broken Object Property Level Authorization",
    "API4:2023 Unrestricted Resource Consumption",
    "API5:2023 Broken Function Level Authorization",
    "API6:2023 Unrestricted Access to Sensitive Business Flows",
    "API7:2023 Server Side Request Forgery",
    "API8:2023 Security Misconfiguration",
    "API9:2023 Improper Inventory Management",
    "API10:2023 Unsafe Consumption of APIs",
  ]},
  { title: "CWE TOP 25", lines: [
    "CWE-79 Cross-site Scripting",
    "CWE-787 Out-of-bounds Write",
    "CWE-89 SQL Injection",
    "CWE-352 Cross-Site Request Forgery",
    "CWE-22 Path Traversal",
    "CWE-125 Out-of-bounds Read",
    "CWE-78 OS Command Injection",
    "CWE-416 Use After Free",
    "CWE-862 Missing Authorization",
    "CWE-434 Unrestricted Upload of Dangerous File Type",
    "CWE-94 Code Injection",
    "CWE-20 Improper Input Validation",
  ]},
  { title: "MITRE ATT&CK", lines: [
    "TA0001 Initial Access",
    "TA0002 Execution",
    "TA0003 Persistence",
    "TA0004 Privilege Escalation",
    "TA0005 Defense Evasion",
    "TA0006 Credential Access",
    "TA0007 Discovery",
    "TA0008 Lateral Movement",
    "TA0009 Collection",
    "TA0010 Exfiltration",
    "TA0011 Command and Control",
    "TA0040 Impact",
  ]},
  { title: "CIS CONTROLS v8", lines: [
    "01 Inventory and Control of Enterprise Assets",
    "02 Inventory and Control of Software Assets",
    "03 Data Protection",
    "04 Secure Configuration of Assets and Software",
    "05 Account Management",
    "06 Access Control Management",
    "07 Continuous Vulnerability Management",
    "08 Audit Log Management",
    "11 Data Recovery",
    "13 Network Monitoring and Defense",
    "17 Incident Response Management",
    "18 Penetration Testing",
  ]},
  { title: "PCI DSS v4.0", lines: [
    "Req 1: Install and Maintain Network Security Controls",
    "Req 2: Apply Secure Configurations",
    "Req 3: Protect Stored Account Data",
    "Req 4: Protect Cardholder Data in Transit",
    "Req 5: Protect Against Malicious Software",
    "Req 6: Develop and Maintain Secure Systems",
    "Req 7: Restrict Access by Need to Know",
    "Req 8: Identify Users and Authenticate Access",
    "Req 9: Restrict Physical Access",
    "Req 10: Log and Monitor All Access",
    "Req 11: Test Security of Systems Regularly",
    "Req 12: Support Security with Policies and Programs",
  ]},
  { title: "ISO/IEC 27001 ANNEX A", lines: [
    "A.5.1 Policies for information security",
    "A.5.7 Threat intelligence",
    "A.5.23 Cloud services security",
    "A.5.30 ICT readiness for business continuity",
    "A.6.3 Security awareness and training",
    "A.7.4 Physical security monitoring",
    "A.8.8 Management of technical vulnerabilities",
    "A.8.9 Configuration management",
    "A.8.16 Monitoring activities",
    "A.8.24 Use of cryptography",
    "A.8.28 Secure coding",
  ]},
  { title: "NIST CSF 2.0", lines: [
    "GV Govern: policy, roles, oversight",
    "ID Identify: asset and risk understanding",
    "PR Protect: safeguards and access control",
    "DE Detect: anomalies and events",
    "RS Respond: containment and communication",
    "RC Recover: restoration and improvement",
    "GV.RM Risk Management Strategy",
    "PR.AA Identity Management and Access Control",
    "DE.CM Continuous Monitoring",
    "RS.AN Incident Analysis",
  ]},
  { title: "NIST SP 800-53 Rev.5", lines: [
    "AC Access Control",
    "AU Audit and Accountability",
    "CA Assessment and Authorization",
    "CM Configuration Management",
    "CP Contingency Planning",
    "IA Identification and Authentication",
    "IR Incident Response",
    "RA Risk Assessment",
    "SC System and Communications Protection",
    "SI System and Information Integrity",
  ]},
  { title: "FATF RECOMMENDATIONS", lines: [
    "R.1 Assessing risks: risk-based approach",
    "R.10 Customer due diligence",
    "R.12 Politically exposed persons",
    "R.15 New technologies",
    "R.16 Wire transfers",
    "R.20 Reporting of suspicious transactions",
    "R.24 Beneficial ownership of legal persons",
    "R.26 Regulation and supervision of financial institutions",
    "R.36 International instruments",
    "R.40 Other forms of international cooperation",
  ]},
  { title: "BASEL III", lines: [
    "CET1 ratio >= 4.5% of RWA",
    "Capital conservation buffer 2.5%",
    "Countercyclical buffer 0 - 2.5%",
    "Leverage ratio >= 3%",
    "LCR: HQLA / 30-day net outflows >= 100%",
    "NSFR: ASF / RSF >= 100%",
    "BCBS 239: risk data aggregation",
    "Pillar 2: supervisory review process",
    "Pillar 3: market discipline and disclosure",
  ]},
  { title: "IEC 62443", lines: [
    "SL1 Protection against casual violation",
    "SL2 Protection against intentional low-resource attack",
    "SL3 Protection against sophisticated attack",
    "SL4 Protection against state-level attack",
    "FR1 Identification and authentication control",
    "FR3 System integrity",
    "FR5 Restricted data flow",
    "FR7 Resource availability",
    "Zones and conduits segmentation model",
  ]},
  { title: "KING IV / COSO ERM", lines: [
    "King IV P1: Ethical and effective leadership",
    "King IV P11: Governance of risk",
    "King IV P12: Governance of technology and information",
    "King IV P15: Combined assurance model",
    "COSO: Governance and Culture",
    "COSO: Strategy and Objective-Setting",
    "COSO: Performance",
    "COSO: Review and Revision",
    "COSO: Information, Communication and Reporting",
  ]},
  { title: "GDPR / POPIA", lines: [
    "GDPR Art.5 Principles of processing",
    "GDPR Art.25 Data protection by design",
    "GDPR Art.32 Security of processing",
    "GDPR Art.33 Breach notification within 72h",
    "POPIA C1: Accountability",
    "POPIA C7: Security safeguards",
    "POPIA s19: Integrity and confidentiality",
    "POPIA s22: Notification of security compromises",
  ]},
];

const POPUP_COLORS = ["#00BB00", "#0088ff", "#ffaa00"];
const POPUP_LIFETIME = 16000;

// Left-hugging navigation for the page sections
const TOC_SECTIONS = [
  { id: "adv-overview", label: "OVERVIEW" },
  { id: "adv-scenarios", label: "SCENARIOS & STRATEGY" },
  { id: "adv-execution", label: "POLICY TO EXECUTION" },
  { id: "adv-serve", label: "WHO WE SERVE" },
  { id: "adv-stand", label: "WHERE WE STAND" },
  { id: "adv-assurance", label: "ASSURANCE" },
  { id: "adv-financial", label: "FINANCIAL & CONDUCT", sub: true },
  { id: "adv-cyber", label: "CYBER", sub: true },
  { id: "adv-fleet", label: "FLEET & WFH", sub: true },
];

// Card styling matched to the introduction section's description card
const cardStyle = {
  marginBottom: "70px",
  background: "rgba(0, 0, 0, 0.75)",
  padding: "25px 30px",
  borderRadius: "10px",
  fontSize: "0.64em",
  lineHeight: "1.7em",
  color: "#CCCCCC"
};

const cardHeadingStyle = {
  fontWeight: "bold",
  color: "#FFFFFF",
  marginBottom: "16px"
};

const paraStyle = {
  marginBottom: "16px"
};

class Advisory extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      popups: [],
      activeSection: TOC_SECTIONS[0].id
    };

    this.nextPopupId = 0;
    this.spawnInterval = null;
    this.removalTimeouts = new Set();

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    // Seed a couple of panels immediately, then keep spawning
    this.spawnPopup();
    this.spawnPopup();
    this.spawnInterval = setInterval(() => this.spawnPopup(), 4200);

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  componentWillUnmount() {
    clearInterval(this.spawnInterval);
    this.removalTimeouts.forEach(t => clearTimeout(t));
    this.removalTimeouts.clear();

    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    // Highlight the last section whose top has passed 40% of the viewport
    const threshold = window.innerHeight * 0.4;
    let active = TOC_SECTIONS[0].id;

    TOC_SECTIONS.forEach(section => {
      const el = document.getElementById(section.id);
      if (el && el.getBoundingClientRect().top <= threshold) {
        active = section.id;
      }
    });

    if (active !== this.state.activeSection) {
      this.setState({ activeSection: active });
    }
  }

  scrollToSection(id) {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    }
  }

  spawnPopup() {
    const stream = STANDARD_STREAMS[Math.floor(Math.random() * STANDARD_STREAMS.length)];
    const id = this.nextPopupId++;

    // Rotate the lines to a random starting point so repeated streams vary
    const offset = Math.floor(Math.random() * stream.lines.length);
    const rotated = [...stream.lines.slice(offset), ...stream.lines.slice(0, offset)];

    // Occasionally highlight a string within a line
    const lines = rotated.map(text => {
      let highlight = null;
      if (Math.random() < 0.25) {
        const words = text.split(' ').filter(w => w.length >= 4);
        if (words.length > 0) {
          highlight = words[Math.floor(Math.random() * words.length)];
        }
      }
      return { text, highlight };
    });

    const popup = {
      id,
      title: stream.title,
      lines,
      x: 2 + Math.random() * 72,     // percent
      y: 4 + Math.random() * 60,     // percent
      height: 180 + Math.floor(Math.random() * 140),  // px — tall panels
      scrollDur: 14 + Math.random() * 10,             // seconds per loop
      color: POPUP_COLORS[Math.floor(Math.random() * POPUP_COLORS.length)]
    };

    this.setState(prevState => {
      const popups = [...prevState.popups, popup];
      // Cap concurrent popups — fewer, taller panels
      return { popups: popups.slice(-4) };
    });

    // Remove after the pop animation completes
    const timeout = setTimeout(() => {
      this.setState(prevState => ({
        popups: prevState.popups.filter(p => p.id !== id)
      }));
      this.removalTimeouts.delete(timeout);
    }, POPUP_LIFETIME);
    this.removalTimeouts.add(timeout);
  }

  renderPopupLine(popup, line, key) {
    if (!line.highlight) {
      return <div className="advisory-popup-line" key={key}>{line.text}</div>;
    }
    const idx = line.text.indexOf(line.highlight);
    return (
      <div className="advisory-popup-line" key={key}>
        {line.text.slice(0, idx)}
        <span style={{ backgroundColor: popup.color, color: "#000000" }}>{line.highlight}</span>
        {line.text.slice(idx + line.highlight.length)}
      </div>
    );
  }

  render() {
    return (
      <div>
        { /* Background: tall panels of open standards text scrolling through */ }
        <div className="advisory-background">
          {this.state.popups.map(popup => (
            <div
              key={`popup-${popup.id}`}
              className="advisory-popup"
              style={{
                left: `${popup.x}%`,
                top: `${popup.y}%`,
                height: `${popup.height}px`,
                color: popup.color,
                borderColor: popup.color,
                animation: `advisoryPop ${POPUP_LIFETIME}ms ease-in-out forwards`
              }}
            >
              <div className="advisory-popup-title">{popup.title}</div>
              <div className="advisory-popup-window">
                <div
                  className="advisory-popup-stream"
                  style={{ animation: `advisoryScroll ${popup.scrollDur}s linear infinite` }}
                >
                  {popup.lines.map((line, i) => this.renderPopupLine(popup, line, `a-${i}`))}
                  {popup.lines.map((line, i) => this.renderPopupLine(popup, line, `b-${i}`))}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="intro-shield">
        </div>

        { /* Left-hugging section navigation */ }
        <nav className="advisory-toc noselect" aria-label="Advisory sections">
          <a
            href="/"
            className="advisory-toc-item advisory-toc-go advisory-toc-go-top"
            onClick={(event) => this.props.onNavigate && this.props.onNavigate('introduction', event)}
          >
            &lsaquo;&nbsp;INTRODUCTION
          </a>
          {TOC_SECTIONS.map(section => (
            <button
              type="button"
              key={section.id}
              className={`advisory-toc-item ${section.sub ? "advisory-toc-sub" : ""} ${this.state.activeSection === section.id ? "advisory-toc-active" : ""}`}
              onClick={() => this.scrollToSection(section.id)}
              aria-current={this.state.activeSection === section.id ? 'location' : undefined}
            >
              {section.label}
            </button>
          ))}
        </nav>

        <div className="content" style={{ marginTop: "50px", minHeight: "60vh", paddingBottom: "80px"}}>

          <CrtTitle text="ADVISORY" style={{ marginBottom: "50px" }} />

          <div className="page-body">
            { /* Tagline and the intersection diagram */ }
            <div id="adv-overview" className="intro-column advisory-section" style={cardStyle}>
              We advise on risk scenarios and strategy in environments where local politics, complex
              regulatory theatres and commercial interests intersect.
              <div style={{ width: "100%", textAlign: "center", marginTop: "25px" }}>
                <svg
                  viewBox="0 0 700 520"
                  className="advisory-venn"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  { /* Rotating dashed outer ring */ }
                  <circle cx="350" cy="250" r="225" fill="none" stroke="#00ff00" strokeWidth="0.8"
                    strokeDasharray="4 14" opacity="0.35">
                    <animateTransform attributeName="transform" type="rotate"
                      values="0 350 250;360 350 250" dur="90s" repeatCount="indefinite" />
                  </circle>
                  <circle cx="350" cy="250" r="240" fill="none" stroke="#00ff00" strokeWidth="0.5"
                    strokeDasharray="1 10" opacity="0.2">
                    <animateTransform attributeName="transform" type="rotate"
                      values="360 350 250;0 350 250" dur="120s" repeatCount="indefinite" />
                  </circle>

                  { /* LOCAL POLITICS circle (red) — slow drift */ }
                  <g>
                    <animateTransform attributeName="transform" type="translate"
                      values="0 0; 10 -7; 0 0; -6 5; 0 0" dur="14s" repeatCount="indefinite" />
                    <circle cx="280" cy="210" r="120" fill="#ff0022" opacity="0.09" />
                    <circle cx="280" cy="210" r="120" fill="none" stroke="#ff0022" strokeWidth="1.2" opacity="0.65" />
                    <circle r="3" fill="#ff0022" opacity="0.9">
                      <animateMotion dur="16s" repeatCount="indefinite"
                        path="M 280,90 a 120,120 0 1,1 -0.1,0 z" />
                    </circle>
                    <text x="185" y="70" fill="#ff0022" fontSize="17" fontFamily="monospace" opacity="0.9">LOCAL POLITICS</text>
                  </g>

                  { /* REGULATORY THEATRES circle (blue) — slow drift */ }
                  <g>
                    <animateTransform attributeName="transform" type="translate"
                      values="0 0; -9 -5; 0 0; 7 6; 0 0" dur="17s" repeatCount="indefinite" />
                    <circle cx="420" cy="210" r="120" fill="#0088ff" opacity="0.09" />
                    <circle cx="420" cy="210" r="120" fill="none" stroke="#0088ff" strokeWidth="1.2" opacity="0.65" />
                    <circle r="3" fill="#0088ff" opacity="0.9">
                      <animateMotion dur="19s" repeatCount="indefinite"
                        path="M 420,90 a 120,120 0 1,0 0.1,0 z" />
                    </circle>
                    <text x="395" y="70" fill="#0088ff" fontSize="17" fontFamily="monospace" opacity="0.9">REGULATORY THEATRES</text>
                  </g>

                  { /* COMMERCIAL INTERESTS circle (green) — slow drift */ }
                  <g>
                    <animateTransform attributeName="transform" type="translate"
                      values="0 0; 6 8; 0 0; -7 -6; 0 0" dur="15s" repeatCount="indefinite" />
                    <circle cx="350" cy="330" r="120" fill="#00ff00" opacity="0.09" />
                    <circle cx="350" cy="330" r="120" fill="none" stroke="#00ff00" strokeWidth="1.2" opacity="0.65" />
                    <circle r="3" fill="#00ff00" opacity="0.9">
                      <animateMotion dur="14s" repeatCount="indefinite"
                        path="M 350,210 a 120,120 0 1,1 -0.1,0 z" />
                    </circle>
                    <text x="260" y="483" fill="#00ff00" fontSize="17" fontFamily="monospace" opacity="0.9">COMMERCIAL INTERESTS</text>
                  </g>

                  { /* Pulsing crosshair on the intersection */ }
                  <g transform="translate(350, 250)">
                    <g>
                      <animateTransform attributeName="transform" type="scale"
                        values="1;1.3;1" dur="3s" repeatCount="indefinite" />
                      <line x1="-26" y1="0" x2="26" y2="0" stroke="#FFFFFF" strokeWidth="1" opacity="0.85" />
                      <line x1="0" y1="-26" x2="0" y2="26" stroke="#FFFFFF" strokeWidth="1" opacity="0.85" />
                      <circle cx="0" cy="0" r="5" fill="none" stroke="#FFFFFF" strokeWidth="1" opacity="0.85" />
                      <circle cx="0" cy="0" r="14" fill="none" stroke="#FFFFFF" strokeWidth="0.5" opacity="0.5" />
                    </g>
                  </g>
                  <text x="350" y="303" fill="#FFFFFF" fontSize="13" fontFamily="monospace" textAnchor="middle" opacity="0.9">COMPLEX RISK</text>
                  <text x="350" y="320" fill="#FFFFFF" fontSize="13" fontFamily="monospace" textAnchor="middle" opacity="0.9">ENVIRONMENT</text>
                </svg>
              </div>
            </div>

            <div id="adv-scenarios" className="intro-column advisory-section" style={cardStyle}>
              <h2 className="card-heading" style={cardHeadingStyle}>RISK SCENARIOS AND STRATEGY</h2>
              <div style={paraStyle}>
                Relentless advises companies on risk scenarios and strategy.  We specialize in complex risk
                environments where local politics, complex regulatory theatres and commercial interests intersect:
                the terrain where a licence, a mandate or a market position can shift with an election cycle,
                a regulator's reinterpretation or a competitor's influence.
              </div>
              <div style={paraStyle}>
                Our work begins with scenario construction: mapping the stakeholders, the incentives and the
                regulatory instruments in play, then stress-testing strategy against the outcomes that matter.
                We draw on two decades of experience in banking, audit, forensics and government engagement to
                tell clients not just what the rules say, but how the theatre actually behaves.
              </div>
              <div>
                Risk does not arrive in one discipline.  A business is exposed through its people, its cash flow,
                theft and embezzlement, its regulators, its contracts and its systems, usually several at once.
                The world is not a fair place, and a business has to survive in it anyway.  We treat HR, financial,
                criminal, regulatory, legal and cyber risk as one terrain, because that is how it behaves.
              </div>
            </div>

            <div id="adv-execution" className="intro-column advisory-section" style={cardStyle}>
              <h2 className="card-heading" style={cardHeadingStyle}>FROM POLICY TO EXECUTION</h2>
              <div style={paraStyle}>
                Advice that stops at a policy document is unfinished.  Our software systems enable clients to
                automate the execution of risk management once policies are in place: continuous control monitoring,
                transaction and cash-flow surveillance, workforce and conduct monitoring, regulatory obligation
                tracking, anomaly detection and evidence trails that stand up to audit and to court.
              </div>
              <div>
                Through <strong style={{ color: "#FFFFFF" }}>Avarice</strong> and our analytics infrastructure, a risk
                policy becomes a running system, measured transparently, escalated automatically and reported in a
                form regulators and boards can rely on.
              </div>
            </div>

            <div id="adv-serve" className="intro-column advisory-section" style={cardStyle}>
              <h2 className="card-heading" style={cardHeadingStyle}>WHO WE SERVE</h2>
              <div style={paraStyle}>
                Our clients are often banks, NGOs, governments, audit firms and management consulting interests:
                institutions whose decisions are scrutinized, whose exposure is systemic and whose credibility is the
                asset most at risk.  We work alongside internal risk, compliance and audit functions, or as an
                independent voice where independence is precisely the point.
              </div>
              <div>
                Relentless maintains a diversified portfolio of clients, and our revenue is not concentrated on any
                particular stakeholder.  That structure lets us often assume a position of genuine independence: no
                single client, sector or institution carries enough weight to bend our analysis, and our advice can
                be given without regard to who would prefer a different answer.
              </div>
            </div>

            <div id="adv-stand" className="intro-column advisory-section" style={cardStyle}>
              <h2 className="card-heading" style={cardHeadingStyle}>WHERE WE STAND</h2>
              <div style={paraStyle}>
                We maintain a strict intolerance of conflicts of interest, corruption and inappropriate
                institutional overreach.  This is not a compliance slogan; in our experience these three failures
                are the root cause of most of the risk events we are hired to untangle.
              </div>
              <div style={paraStyle}>
                <strong style={{ color: "#FFFFFF" }}>Conflicts of interest.</strong> We disclose them, and where they
                cannot be managed, we decline the work.  We will not advise opposing sides of the same theatre, and we
                do not accept incentives that could bend our analysis.  Advice is only worth what its independence costs.
              </div>
              <div style={paraStyle}>
                <strong style={{ color: "#FFFFFF" }}>Corruption.</strong> We have zero-tolerance for any forms of
                corruption and inappropriate incentives.
              </div>
              <div style={paraStyle}>
                <strong style={{ color: "#FFFFFF" }}>Institutional overreach.</strong> Power exercised beyond mandate is
                itself a risk event, whether it comes from a regulator, a state organ or a dominant commercial actor.
                We help clients resist inappropriate overreach through lawful means: documentation, due process and
                transparent escalation.  Equally, we will not lend our tools or expertise to surveillance or coercion
                that exceeds a lawful mandate.
              </div>
              <div style={paraStyle}>
                Alongside those three intolerances stands one obligation.
              </div>
              <div>
                <strong style={{ color: "#FFFFFF" }}>Confidentiality.</strong> Almost all of our work is confidential,
                and we operate under strict internal policies built around that constraint.  We do not name clients,
                disclose engagements or publish case studies, and what we learn inside one theatre is never carried
                into another.  Access to client material is limited to those working on the engagement, and the
                evidence we gather is handled as if it will one day be examined in court.  Discretion is not a courtesy
                we extend; it is a condition of the work.
              </div>
            </div>

            <div id="adv-assurance" className="intro-column advisory-section" style={cardStyle}>
              <h2 className="card-heading" style={cardHeadingStyle}>ASSURANCE</h2>
              <div style={{ marginBottom: "30px" }}>
                Where our advisory work shapes strategy, our assurance work tests claims, in whatever dimension the
                claim is made: that the controls over cash are sound, that a workforce is doing the work it is paid
                for, that a regulatory obligation is actually met, that a system is secure.  Assurance, for us, is not
                a checklist signed at a distance; it is a claim subjected to the conditions it is supposed to survive.
              </div>

              <h2 id="adv-financial" className="advisory-section card-heading" style={cardHeadingStyle}>FINANCIAL AND CONDUCT ASSURANCE</h2>
              <div style={{ marginBottom: "30px" }}>
                Cash, credit and conduct are where most losses actually happen: theft, embezzlement, fraud, undisclosed
                conflicts and cash-flow exposure.  We test the controls over money and the people who handle it, and
                where a control has failed, we establish what was taken, by whom and how.
              </div>

              <h2 id="adv-cyber" className="advisory-section card-heading" style={cardHeadingStyle}>CYBER ASSURANCE</h2>
              <div style={paraStyle}>
                Security is one such claim.  Our cyber work takes the form of thorough due diligences and audits in
                which every assertion is grounded in a battle test: we advise on whether a security claim is true,
                and we run the experiments to find out.
              </div>
              <div style={paraStyle}>
                That discipline starts at home.  Our own systems run in forensic, financial and contested settings,
                where a weakness is found by an adversary before it is found by an auditor.  Defending them keeps us
                current with attacks as they emerge, not as they are written up afterwards.
              </div>
              <div style={{ marginBottom: "30px" }}>
                <strong style={{ color: "#FFFFFF" }}>Operational technology.</strong> Operational technology (OT) is
                the hardware and software that controls physical equipment: the sensors, controllers and control
                networks that run plants, mines, utilities and production lines.  As more of this infrastructure is
                connected to corporate networks and the internet, intrusion where capital equipment is exposed has
                become a growing risk terrain, and one in which we have some expertise.  A compromised ledger loses money; a compromised plant loses
                machinery, production and sometimes lives.  Our engineering background in sensors, control systems and
                industrial visualization lets us reason about these environments as operators do, not only as auditors do.
              </div>

              <h2 id="adv-fleet" className="advisory-section card-heading" style={cardHeadingStyle}>FLEET AND WFH ASSURANCE</h2>
              <div style={paraStyle}>
                This is where people risk meets measurement.  Large distributed organizations and work-from-home
                arrangements have stretched the corporate effort across thousands of screens, sites and time zones.
                Our fleet and WFH assurance practice monitors staff across these environments to check whether the
                work being done is the work the mandate calls for.
              </div>
              <div>
                Built on the same infrastructure that runs our boots-on-the-ground platforms, it measures
                activity against policy and objective rather than presence for its own sake.  Consistent with where we
                stand on overreach, it operates within a disclosed policy and a lawful mandate: measurement in service
                of the organization, not surveillance for its own sake.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Advisory;
